import React, { useEffect } from "react";
import { Container, Box, Typography } from "@mui/material";
import { updateMetaTags } from "../utils/seo";
import Footer from "../components/Footer";
import HackerNews from "../components/HackerNews";
import BackToWorldButton from "../components/BackToWorldButton";

const HackerNewsPage: React.FC = () => {
  useEffect(() => {
    updateMetaTags({
      title: "Hacker News - Tech Stories & Discussions",
      description:
        "Explore trending tech stories, Ask HN discussions, and Show HN projects from Hacker News",
      keywords: "hacker news, tech news, programming, startups, technology",
      canonical: `${window.location.origin}/news`,
      ogTitle: "Hacker News - Tech Stories & Discussions",
      ogDescription:
        "Explore trending tech stories, Ask HN discussions, and Show HN projects from Hacker News",
      ogUrl: `${window.location.origin}/news`,
      ogType: "website",
      twitterCard: "summary",
      twitterTitle: "Hacker News - Tech Stories & Discussions",
      twitterDescription:
        "Explore trending tech stories, Ask HN discussions, and Show HN projects from Hacker News",
    });
  }, []);

  return (
    <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <Box
        sx={{
          py: { xs: 6, md: 8 },
          backgroundColor: "background.paper",
          borderBottom: "1px solid",
          borderColor: "divider",
        }}
      >
        <Container maxWidth="md">
          <Typography
            variant="h3"
            component="h1"
            sx={{
              fontWeight: 700,
              mb: 2,
              textAlign: "center",
              color: "#ff6600",
            }}
          >
            🔥 Hacker News
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{
              color: "text.secondary",
              textAlign: "center",
              mb: 2,
            }}
          >
            Top tech stories, discussions, and projects from the community
          </Typography>
          <Typography
            variant="caption"
            sx={{
              display: "block",
              color: "text.disabled",
              textAlign: "center",
              mb: 2,
            }}
          >
            Stories and links sourced from the{" "}
            <a
              href="https://news.ycombinator.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#ff6600" }}
            >
              Hacker News
            </a>{" "}
            public API. All content belongs to its respective authors and
            publishers.
          </Typography>
        </Container>
      </Box>

      <Container maxWidth="xl" sx={{ py: 4, flex: 1 }}>
        <HackerNews count={6} variant="grid" />
      </Container>

      <Footer />
      <BackToWorldButton />
    </Box>
  );
};

export default HackerNewsPage;
